import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import { Card, Badge, Table } from "react-bootstrap";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

const ProductView = () => {
  const { id } = useParams();
  const API = process.env.REACT_APP_API_BASE_URL;
  const [product, setProduct] = useState(null);
  const [warehouses, setWarehouses] = useState([]);
  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, defaultValue) => translations[key] || defaultValue;

  useEffect(() => {
    axios.get(`${API}/api/warehouses/active`).then((res) => {
      setWarehouses(res.data);
    });
  }, []);
  const getWarehouseName = (id) => {
    const wh = warehouses.find((w) => Number(w.id) === Number(id));
    return wh ? wh.title : getText("WAREHOUSE_FALLBACK", `Depo ${id}`);

  };
  useEffect(() => {
    axios.get(`${API}/api/products/${id}`).then((res) => setProduct(res.data));
    console.log(product);
  }, [API, id]);

  if (!product) return <div className="container mt-4"> {getText("LOADING")}</div>;

  const getMainImage = (product, API) => {
    if (product.main_image) return `${API}${product.main_image}`;
    return null;
  };
  const getImage = (cdnUrl, localPath) => {
    if (cdnUrl) return cdnUrl;
    if (localPath) return `${API}/cdn${localPath}`;
    return null;
  };

  return (
    <div className="container mt-4">
      {/* === ÜRÜN BİLGİLERİ === */}
      <Card className="shadow-sm mb-4 p-3">
        <h4 className="border-bottom pb-2">{getText("PRODUCT_INFORMATIONS")}</h4>
        {/* --- KATEGORİ SATIRI (compact) --- */}
        {product.categories?.length > 0 && (
          <div className="mb-3">
            <strong>{getText("MENU_CATEGORIES")} </strong>
            {product.categories.map((c) => (
              <Badge
                key={c}
                bg="info"
                className="me-2"
                style={{ fontSize: "0.85rem", padding: "6px 10px" }}
              >
                {product.category_name?.[c] || getText("CATEGORY_FALLBACK", `Kategori ${c}`)}

              </Badge>
            ))}
          </div>
        )}

        <Table bordered hover size="sm">
          <tbody>
            <tr>
              <td>
                <strong>{getText("TITLE")}</strong>
              </td>
              <td>{product.title}</td>
            </tr>

            <tr>
              <td>
                <strong>{getText("TABLE_BARCODE_LABEL")}</strong>
              </td>
              <td>{product.barcode || "-"}</td>
            </tr>
            <tr>
              <td>
                <strong>{getText("MENU_BRANDS")}</strong>
              </td>
              <td>{product.brand?.title}</td>
            </tr>

            <tr>
              <td>
                <strong>{getText("TABLE_STATUS_LABEL")}</strong>
              </td>
              <td>
               {product.status === "aktif" ? (
  <Badge bg="success">
    {getText("STATUS_ACTIVE", "Aktif")}
  </Badge>
) : (
  <Badge bg="secondary">
    {getText("STATUS_PASSIVE", "Pasif")}
  </Badge>
)}

              </td>
            </tr>
          </tbody>
        </Table>
      </Card>

      {/* === FİYAT BİLGİLERİ === */}
      <Card className="shadow-sm mb-4 p-3">
        <h4 className="border-bottom pb-2">{getText("PRICE_INFORMATION")}</h4>

        <Table bordered size="sm">
          <tbody>
            <tr>
              <td width="200">
                <strong>{getText("MENU_CURRENCY")}</strong>
              </td>
              <td>
                {product.currency?.code} ({product.currency?.symbol})
              </td>
            </tr>

            <tr>
              <td>
                <strong>{getText("PRICE")}</strong>
              </td>
              <td className="fs-5 text-primary">
                <strong>{product.price}</strong> {product.currency?.symbol}
              </td>
            </tr>

            <tr>
              <td>
                <strong>{getText("DISCOUNT_PRICE")}</strong>
              </td>
              <td className="fs-5 text-danger">
                {product.discount_price ? (
                  <>
                    <strong>{product.discount_price}</strong>{" "}
                    {product.currency?.symbol}
                  </>
                ) : (
                  <span className="text-muted"> </span>
                )}
              </td>
            </tr>
          </tbody>
        </Table>
      </Card>

      {/* === STOK BİLGİLERİ === */}
      <Card className="shadow-sm mb-4 p-3">
        <h4 className="border-bottom pb-2">{getText("STOCK_INFORMATION")}</h4>

        {!product.stock || Object.keys(product.stock).length === 0 ? (
          <div className="alert alert-success">
  {getText("UNLIMITED_STOCK")}
</div>

        ) : (
          <Table bordered size="sm">
            <thead>
              <tr>
                <th width="200">{getText("MENU_WAREHOUSES")}</th>
                <th>{getText("TABLE_STOCK_LABEL")}</th>
              </tr>
            </thead>

            <tbody>
              {Object.entries(product.stock).map(([warehouseId, qty]) => (
                <tr key={warehouseId}>
                  <td>
                    <strong>{getWarehouseName(warehouseId)}</strong>
                  </td>

                  <td>
                    {qty == 0 ? (
                      <Badge bg="danger">
  {getText("OUT_OF_STOCK")}
</Badge>

                    ) : (
                      <Badge bg="success">{qty} {getText("PIECE")}</Badge>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Card>

      {/* === GÖRSELLER === */}
      <Card className="shadow-sm mb-4 p-3">
        <h4 className="border-bottom pb-2">{getText("IMAGES")}</h4>

        {/* --- ANA GÖRSEL --- */}
        <h6>{getText("MAIN_IMAGE")}</h6>
        {product.main_image ? (
          <img
            src={`${API}${product.main_image}`}
            alt=""
            className="rounded border mb-3"
            style={{ width: "250px", height: "250px", objectFit: "cover" }}
          />
        ) : (
          <p className="text-muted"> </p>
        )}

        {/* --- GALERİ --- */}
        <h6 className="mt-3">{getText("GALERY")}</h6>
        <div className="d-flex flex-wrap gap-2">
          {Array.isArray(product.gallery) && product.gallery.length > 0 ? (
            product.gallery.map((img, i) => (
              <img
                key={i}
                src={`${API}${img}`}
                className="rounded border"
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                }}
                alt=""
              />
            ))
          ) : (
            <p className="text-muted"> </p>
          )}
        </div>
      </Card>

      {/* === ÜRÜN ÖZELLİKLERİ === */}
      <Card className="shadow-sm mb-4 p-3">
        <h4 className="border-bottom pb-2">{getText("PRODUCT_FEATURES")}</h4>

        {product.features_detail &&
        Object.keys(product.features_detail).length > 0 ? (
          <Table bordered size="sm">
            <tbody>
              {Object.entries(product.features_detail).map(([fid, obj]) => (
                <tr key={fid}>
                  <td width="200">
                    <strong>{obj.name}</strong>
                  </td>
                  <td>{obj.values.join(", ")}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <p className="text-muted"> </p>
        )}
      </Card>

      {/* === AÇIKLAMALAR === */}
      <Card className="shadow-sm mb-4 p-3">
        <h4 className="border-bottom pb-2">{getText("DESCRIPTIONS")}</h4>

        <strong>{getText("SHORT_DESCRIPTION")}</strong>
        <div className="border rounded p-2 mt-1 mb-3 bg-light">
          {product.short_description || <span className="text-muted"> </span>}
        </div>

        <strong>{getText("CONTENT")}</strong>
        <div
          className="border rounded p-3 mt-1 bg-light"
          dangerouslySetInnerHTML={{
            __html: product.content || '<span class="text-muted"> </span>',
          }}
        />
      </Card>

      {/* === SEO BİLGİLERİ === */}
      <Card className="shadow-sm mb-4 p-3">
        <h4 className="border-bottom pb-2">{getText("MENU_SETTINGS_SEO")}</h4>

        <Table bordered size="sm">
          <tbody>
            <tr>
              <td width="200">
                <strong>{getText("SEO_TITLE")}</strong>
              </td>
              <td>{product.seo_title || " "}</td>
            </tr>

            <tr>
              <td>
                <strong>{getText("SEO_DESCRIPTION")}</strong>
              </td>
              <td>{product.seo_description || " "}</td>
            </tr>

            <tr>
              <td>
                <strong>{getText("SEO_KEYWORDS")}</strong>
              </td>
              <td>{product.seo_keywords || " "}</td>
            </tr>
          </tbody>
        </Table>
      </Card>

      {/* === TARİH BİLGİLERİ === */}
      <Card className="shadow-sm mb-4 p-3">
        <h4 className="border-bottom pb-2">{getText("DATE_INFORMATIONS")}</h4>

        <Table bordered size="sm">
          <tbody>
            <tr>
              <td width="200">
                <strong>{getText("LABEL_CREATED_AT")}</strong>
              </td>
              <td>{new Date(product.createdAt).toLocaleString("tr-TR")}</td>
            </tr>
            <tr>
              <td>
                <strong>{getText("TABLE_UPDATED_AT")}</strong>
              </td>
              <td>{new Date(product.updatedAt).toLocaleString("tr-TR")}</td>
            </tr>
          </tbody>
        </Table>
      </Card>

      {/* === BUTONLAR === */}
      <div className="d-flex gap-2 mb-4">
        <Link to="/products/table" className="btn btn-secondary">
          ← {getText("BACK")}
        </Link>
        <Link to={`/products/edit/${product.id}`} className="btn btn-primary">
          {getText("EDIT")}
        </Link>
      </div>
    </div>
  );
};

export default ProductView;
